import { requestHandler } from 'utils/functions';
import { AppDispatch } from '../store';
import apiServices from 'api_services/request-handler';
import { setUser } from '../slices/common-slice';
import { setAuthLoading } from '../slices/auth-slice';

export const login = (data: LoginSchema, onDone: () => void) => {
  return async (dispatch: AppDispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.login,
        setLoading: setAuthLoading,
        param_data: data,
        isSuccessMessage: true,
        setData: setUser,
        onDone
      }),
    );
  };
};
